import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import {
  addPending,
  getPending,
  hasPending,
  markPendingError,
  markPendingSent,
  updatePending,
} from "../MessagesList/pendingStore";

// Envio sem travar a barra de digitação: a bolha "enviando" aparece na hora e o POST segue
// em segundo plano. Os corpos dos pedidos são os mesmos de antes.

// Textos da mesma conversa saem um de cada vez, para chegarem na ordem em que foram escritos.
const chains = new Map();
const enqueue = (ticketId, task) => {
  const previous = chains.get(ticketId) || Promise.resolve();
  const next = previous.then(task, task);
  chains.set(ticketId, next.catch(() => {}));
  return next;
};

const errorTextOf = (err) => {
  const code = err && err.response && err.response.data && err.response.data.error;
  if (!code) return null;
  return i18n.exists(`backendErrors.${code}`) ? i18n.t(`backendErrors.${code}`) : String(code);
};

export const sendTextOptimistic = ({ ticketId, payload }) => {
  let localId = null;
  const run = () => {
    updatePending(localId, { status: "sending", errorText: null });
    return enqueue(ticketId, async () => {
      if (!hasPending(localId)) return; // descartada enquanto esperava a vez
      try {
        const { data } = await api.post(`/messages/${ticketId}`, payload);
        markPendingSent([localId], data);
      } catch (err) {
        toastError(err);
        markPendingError([localId], errorTextOf(err));
      }
    });
  };
  localId = addPending(ticketId, {
    kind: "text",
    body: payload.body,
    isPrivate: payload.isPrivate === "true" || payload.isPrivate === true,
    quotedMsg: payload.quotedMsg || null,
    retry: run,
  });
  run();
  return localId;
};

export const mediaKindOfFile = (file, voice) => {
  const type = String((file && file.type) || "");
  if (voice || type.startsWith("audio/")) return "audio";
  if (type.startsWith("image/")) return "image";
  if (type.startsWith("video/")) return "video";
  return "file";
};

// items: [{ file, fileName, caption, voice }]; buildFormData(itens ainda na fila) monta o
// corpo exatamente como o envio daquele tipo sempre fez.
export const sendMediaOptimistic = ({ ticketId, items, isPrivate, buildFormData }) => {
  const groupId = `g${Date.now()}-${Math.round(Math.random() * 1e6)}`;
  let ids = [];
  const run = () => {
    const live = getPending(ticketId).filter((e) => e.groupId === groupId);
    if (live.length === 0) return Promise.resolve();
    const liveIds = live.map((e) => e.localId);
    liveIds.forEach((id) => updatePending(id, { status: "sending", progress: 0, errorText: null }));
    return api
      .post(`/messages/${ticketId}`, buildFormData(live.map((e) => e.item)), {
        onUploadProgress: (e) => {
          if (!e.total) return;
          const progress = Math.min(100, Math.round((e.loaded * 100) / e.total));
          liveIds.forEach((id) => updatePending(id, { progress }));
        },
      })
      .then(({ data }) => markPendingSent(liveIds, data))
      .catch((err) => {
        toastError(err);
        markPendingError(liveIds, errorTextOf(err));
      });
  };
  ids = items.map((item) => {
    const mediaKind = item.mediaKind || mediaKindOfFile(item.file, item.voice);
    let previewUrl = null;
    try {
      previewUrl = window.URL.createObjectURL(item.file);
    } catch (e) {
      previewUrl = null;
    }
    return addPending(ticketId, {
      kind: "media",
      groupId,
      item,
      mediaKind,
      voice: !!item.voice,
      previewUrl,
      fileName: item.fileName || (item.file && item.file.name) || "arquivo",
      fileSize: (item.file && item.file.size) || 0,
      body: item.caption || "",
      isPrivate: !!isPrivate,
      quotedMsg: null,
      retry: run,
    });
  });
  run();
  return ids;
};
